import { activityStatus } from "../constants/constants";
import { GetBrandedTutorName, GetBrandedAppName } from "./BrandingService";


// TODO merge w activity status in constants
export const statusType = {
  //ABANDONED: 'abandoned', //TODO implement this on the backend
  //REVIEWED: 'reviewed', //TODO implement this on the backend
  RESCORED: 'rescored',
  SCORED: 'scored',
  ASSIGNED: 'assigned',
  ASSIGNED_WITH_SPACES: ' assigned ',
  NOT_STARTED: 'not_started', //TODO do backend work to make this work for assigned assessments too, right now it only works for self assigned assessments
  IN_PROGRESS: 'in_progress',
  SCORING: 'scoring',
  LAUNCHED: 'launched', //Activity started
  STARTED: 'started', //Student started the activity and at least got to the point where they see the first page
  ABORTED: 'aborted', //Student hit the abort button
  ABANDONED: 'abandoned', //Student closed the browser mid-activity. TODO: Implement this when the browser closes.
  DOWNLEVELED: "downleveled", // We decided to downlevel the student
  PREREADER: "prereader", //We downleveled the student out of K
  COMPLETED: "completed", //Student finished the test and is waiting to be scored
  UNASSIGNED: 'unassigned', //An "assignment" activity has been unassigned, typically done when the assignment has been started
  RESCORING: 'rescoring', //Submitted for rescoring by scoring screen
  MUTED: 'muted', //Aborted because of muted audio
  STUCK_PLACEMENT: 'stuck_placement',
  UNDER_REVIEW: 'underReview', //Activity flagged for review
  ARCHIVED: 'archived',
};

export const displayStatusLabels = {
  reassess: "REASSESS",
  earlyReader: "EARLY READER",
  incomplete: "INCOMPLETE",
  inProgress: "IN PROGRESS",
  scoring: "SCORING...",
  underReview: "UNDER REVIEW...",
  complete: "COMPLETE",
  assigned: "ASSIGNED",
  unassessed: "UNASSESSED",
  aborted: "ABORTED", //not currently used
  scored: "SCORED",
}

export const pendingStatuses = {
  inProgress: "IN PROGRESS",
  underReview: "UNDER REVIEW...",
  scoring: "SCORING...",
  reassess: "REASSESS",
}

export const pendingStatusLabels = {
  UNDER_REVIEW: 'underReview',
  IN_PROGRESS: 'in_progress',
  SCORING: 'scoring',
  REASSESS: 'reassess'
}

export const statusTooltips = {
  "UNASSESSED": {
    label: "Unassessed",
    description: `the student has not been assigned an assessment in the <b>current</b> testing window. If your school is using ${GetBrandedAppName()} Practice, the student will get Practice stories until an assessment is assigned.`,
    CTA: `To assess the student, assign an assessment, then instruct the student to log-in to ${GetBrandedAppName()} as they normally would.`,
  },
  "ASSIGNED": {
    label: "Scheduled",
    description: "the student has been assigned an assessment and will be given the assessment the next time the student logs in.",
    CTA: "Instruct the student to log in and complete the assessment.",
  },
  "IN_PROGRESS": {
    label: "In Progress",
    description: "the student is currently taking an assessment. The assessment will be scored when completed.",
    CTA: "After the student has finished the assessment, check the score on the Benchmark Report. If the student logged out during the assessment, the student will be able to complete the assessment upon the next login.",
  },
  "ERROR": {
    label: "Reassess",
    description: "the student completed the assessment, but an issue occurred which does not allow for a valid score.",
    CTA: "Click on the student's name and re-assign this assessment, then instruct the student to log in to take the assessment. (Prior to reassessing, check the student's headphones or open tabs which might be interfering with the audio file.)",
  },
  "SCORING": {
    label: "Scoring",
    description: "the assessment has been saved and is in the scoring process. Scoring can take a few minutes or up to several hours to complete.",
    CTA: "Wait for the scoring process to finish, then check the score on the Benchmark Report. If the status of SCORING is displayed for more than 24 hours, Chat with us or contact support.",
  },
  "COMPLETE": {
    label: "Complete",
    description: "the student has completed the assessment. The student's score is available in the Benchmark Report.",
    CTA: `If your school is using ${GetBrandedAppName()} Practice, ask the student to log in and work with ${GetBrandedTutorName()} several times a week.`,
  },
  "UNDER_REVIEW": {
    label: "Under Review",
    description: "the assessment session has been flagged for an in-depth quality review. The review process can take 3 business days, not including the day the assessment was taken. For example, an assessment completed on Monday will be reviewed by Friday morning.",
    CTA: "Check back in a few days. The status will change to \"Complete\" or \"Reassess\" once reviewed. If this takes more than 5 business days, please contact Support or Chat with us.",
},
  "PRE-READER": {
    label: "Early Reader",
    description: "the student struggled to read the kindergarten passage or the student did not read enough words correctly to enable a score.",
    CTA: `If you agree the student is an early reader, ask them to login and work with ${GetBrandedTutorName()} through the early skills scaffold. If you disagree, review the student's audio and if you then judge that the student is a solid reader, either remove from the Skills Scaffold or assign a new assessment.`,
  },
  "INCOMPLETE": {
    label: "Not Completed",
    description: "the student's session ended before the assessment was completed. This can occur because the student is closing or leaving the browser.",
    CTA: "Instruct the student to log in and resume the assessment.",
  },
  "DISTRICT_ASSIGNED": {
    label: "District Assigned",
    description: `your district has created an assessment window. This student will be assessed as soon as they launch ${GetBrandedAppName()}.`,
    CTA: "Instruct the student to log in and complete the assessment.",
  }
}

export function getActivityStatus(activity, includeChildrenInUnderReview=true){

  // If there is no activity, then the activity has no status
  if(!activity) {
    return null;
  }

  let status = activity.status;
  let displayStatus = activity.displayStatus;
  let updatedAt = activity.updatedAt || activity.createdAt;

  if(activity.assessmentStatus){//This is used on Tracking Report
    status = activity.assessmentStatus.id;
  }

  // if we don't have an activity,
  //  or the activity is not currently being scored but also has no scores,
  //  mark as an error
  if((displayStatus !== statusType.PREREADER) && (!activity
        || !status
        || (status == statusType.SCORED && (activity.type === "assessment") && !(activity.scores && activity.scores.wcpmScore > 0))
  )){
    return {
      label: displayStatusLabels.reassess,
      id: "ERROR",
      needsAttention: true,
    };
  }

  //UNDER REVIEW: The activity or any if it's children are flagged for review
  if(((displayStatus === statusType.UNDER_REVIEW || status === statusType.UNDER_REVIEW
    || (activity.children && activity.children.some(x => x.status === statusType.UNDER_REVIEW)))
    && includeChildrenInUnderReview) || ((displayStatus === statusType.UNDER_REVIEW
    || status === statusType.UNDER_REVIEW) && !includeChildrenInUnderReview)){
    return {
      id: "UNDER_REVIEW",
      label: displayStatusLabels.underReview,
      started: true,
      ready: true,
      hideScore: true,
    };
  }


  // Partially completed assignments are either multipart assignments in which some, but not all of the parts have been completed,
  //   or assignments with a status of "started" (which is set when an activity starts, and remains until the activity
  //   is terminated by downleveling, abort, timeout, or even sometimes finishing normally.)
  // If enabled, reading comprehension is the last activity in the progression but is a child of the ORF activity.
  //   As a result, assessments can still be scored/completed when the reading comp activity is abandoned.
  //   To show the appropriate status in the case, we check if scored/completed have any children in the assigned state.
  // We will mark assignments in this partially completed state as "IN PROGRESS" for the first 10 minutes (hopefully approximately *while* the student is taking the test)
  //   but if more than 10 minutes pass with an assignment in this state, and no update, we will mark the assignment as "INCOMPLETE"
  //   as a call to action for the teacher to have the student log back in and finish the assignment
  if((status == statusType.ASSIGNED && (displayStatus == statusType.STARTED || (activity.children && (activity.children.length > 0))))
    || (displayStatus == statusType.COMPLETED && activity.children && activity.children.some(c => c.status === activityStatus.ASSIGNED))){
    if(updatedAt && (new Date() - new Date(updatedAt)) > 600000){
      return {
        id: "INCOMPLETE",
        label: displayStatusLabels.incomplete,
        needsAttention: true,
        started: true,
      };
    }else{
      return {
        id: "IN_PROGRESS",
        label: displayStatusLabels.inProgress,
        started: true,
      };
    }
  }

  //PREREADER: Downleveled out of K and scored
  if(displayStatus == statusType.PREREADER){
    return {
      id: "PRE-READER",
      label: displayStatusLabels.earlyReader,
      ready: true,
      needsAttention: true,
    };
  }

  // ABORTED: User hit end assessment and the test is not scored
  if(displayStatus == statusType.ABORTED && status !== statusType.SCORED){
    return {
      id: "REASSESS (aborted)",
      label: displayStatusLabels.aborted,
      ready: true,
      needsAttention: true,
    };
  }

  //SCORING: The activity was marked as completed and it's not yet scored (for whatever reason)
  if((displayStatus == statusType.COMPLETED) && ((status !== statusType.SCORED) && (status !== statusType.RESCORED))){
    return {
      id: "SCORING",
      label: displayStatusLabels.scoring,
      started: true,
    };
  }

  switch(status.toLowerCase()) {
    case statusType.SCORED:
    case statusType.RESCORED:
      return {
        id: "COMPLETE",
        label: displayStatusLabels.complete,
        ready: true,
      };
    case statusType.ASSIGNED:
    case statusType.ASSIGNED_WITH_SPACES:
      return {
        id: "ASSIGNED",
        label: displayStatusLabels.assigned,
      };

    default:
      return {
        id: "ERROR",
        label: displayStatusLabels.reassess,
        needsAttention: true,
      };
  }
}
